const SET_PROPERTY = 'SET_PROPERTY_EXPORTS_PAGE';
const REMOVE_EXPORT_FROM_LIST = 'REMOVE_EXPORT_FROM_LIST_EXPORTS_PAGE';
const SET_EXPORT_DELETING_PROGRESS = 'SET_EXPORT_DELETING_PROGRESS_EXPORTS_PAGE';
const SET_EXPORT_STATUS = 'SET_EXPORT_STATUS_EXPORTS_PAGE';
const UPDATE_EXPORTS_POSITIONS = 'UPDATE_EXPORTS_POSITIONS';
const UPDATE_EXPORT_PROGRESS = 'UPDATE_EXPORT_PROGRESS_EXPORTS_PAGE';

export const types = {
    SET_PROPERTY,
    REMOVE_EXPORT_FROM_LIST,
    SET_EXPORT_DELETING_PROGRESS,
    SET_EXPORT_STATUS,
    UPDATE_EXPORTS_POSITIONS,
    UPDATE_EXPORT_PROGRESS
};